// publicationColors.js

const publicationColors = {
  default: '#3498db', // fallback color
  map: {
    greenpub: '#27ae60', 
    alpha: '#2980b9',   
    mikkypub: '#d11d85',   
    ijrdo: '#8e44ad',  
    riset: '#9b59b6',   
    ink: '#1abc9c',  
    eph: '#9580e1',  
    writerr: '#9580e1',    
    alpha: '#cd2e1e',    
    scriptspace: '#34495e',    
    // #6f1818
  },
};

export const getPublicationColor = (publicationName) => {
  if (!publicationName) return publicationColors.default;
  return publicationColors.map[publicationName.toLowerCase()] || publicationColors.default;
};

export default publicationColors;
